import { ResumenLlaveByClienteProductoUsuario } from "../../bussines/entities/EstadisticasLlave.entity";

export class ResumenLlaveByClienteProductoUsuarioModel implements ResumenLlaveByClienteProductoUsuario {
    constructor(
        public ruc: string,
        public razonsocial: string,
        public producto: string,
        public usuario: string,
        public mes: number,
        public value: number
    ) { }

    serialize(): ResumenLlaveByClienteProductoUsuario {
        return {
            ruc: this.ruc,
            razonsocial: this.razonsocial,
            producto: this.producto,
            usuario: this.usuario,
            mes: this.mes,
            value: this.value
        }
    }

    static deserialize(entity: ResumenLlaveByClienteProductoUsuario): ResumenLlaveByClienteProductoUsuarioModel {
        return new ResumenLlaveByClienteProductoUsuarioModel(
            entity.ruc ?? '',
            entity.razonsocial ?? '',
            entity.producto ?? '',
            entity.usuario ?? '',
            entity.mes ?? 0,
            entity.value ?? 0
        );
    }
}